<template>
    <div class="section-container">
        <swiper :options="swiperOptionNav" class="nav-swiper-container" ref="swiperNav" @slide-change="getSlideIndex">
            <swiper-slide v-for="item in sectionData">{{item.name}}</swiper-slide>
        </swiper>
        <swiper :options="swiperOptionImages" ref="swiperImages" class="card-swiper-container">
            <swiper-slide v-for="(item,index) in sectionData">
                <div class="card-slide">
                    <div class="title-container">
                        <svg class="title-arrow" version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="11.904px" height="81.21px" viewBox="0 0 11.904 81.21" enable-background="new 0 0 11.904 81.21" xml:space="preserve">
<path :fill="item.backgroundColor" d="M0,0l5.953,4.443L11.906,0v3.953L5.953,8.397L0,3.953V0z"/>
<path :fill="item.backgroundColor" d="M0,8.09l5.953,4.443l5.953-4.443v3.953l-5.953,4.444L0,12.043V8.09z"/>
<path :fill="item.backgroundColor" d="M0,16.18l5.953,4.443l5.953-4.443v3.953l-5.953,4.445L0,20.133V16.18z"/>
<path :fill="item.backgroundColor" d="M0,24.271l5.953,4.444l5.953-4.444v3.954l-5.953,4.443L0,28.225V24.271z"/>
<path :fill="item.backgroundColor" d="M0,32.359l5.953,4.443l5.953-4.443v3.954l-5.953,4.444L0,36.313V32.359z"/>
<path :fill="item.backgroundColor" d="M0,40.451l5.953,4.443l5.953-4.443v3.953l-5.953,4.445L0,44.404V40.451z"/>
<path :fill="item.backgroundColor" d="M0,48.541l5.953,4.443l5.953-4.443v3.953l-5.953,4.443L0,52.494V48.541z"/>
<path :fill="item.backgroundColor" d="M0,56.63l5.953,4.443l5.953-4.443v3.953l-5.953,4.443L0,60.583V56.63z"/>
<path :fill="item.backgroundColor" d="M0,64.72l5.953,4.443l5.953-4.443v3.953l-5.953,4.443L0,68.673V64.72z"/>
<path :fill="item.backgroundColor" d="M0,72.81l5.953,4.443l5.953-4.443v3.953l-5.953,4.443L0,76.763V72.81z"/>
</svg>
                        <div>
                            <p class="title-line1"
                               :style="{color:item.backgroundColor,textShadow:`2px 1px #fff, 3px 2px ${item.backgroundColor}, 1px 1px ${item.backgroundColor}`}">
                                {{firstLineTitles[index]}}</p>
                            <p class="title-line2"
                               :style="{color:item.backgroundColor,textShadow:`2px 1px #fff, 3px 2px ${item.backgroundColor}, 1px 1px ${item.backgroundColor}`,paddingTop:firstLineTitles[index]?'0.17rem':''}">
                                {{secondLineTitles[index]}}</p>
                        </div>
                    </div>
                    <div :class="[firstLineTitles[index]?'small-img':'big-img']">
                        <img v-if="tabIndex===1" class="slide-img" :src="baseUrl+item.pic.url" alt="">
                        <div v-if="tabIndex===2" class="news-imge-container">
                            <div class="news-info">
                                <p class="display-time f-GOTHICB">
                                    {{newsDisplayTime}}</p>
                                <p class="description f-GOTHIC">
                                    {{newsImages[index][0].description}}</p>
                                <router-link
                                        :to="{name:'news',params:{slug:newsImages[index][0].slug,parent:item.slug}}"
                                        tag="p" class="learn-more f-GOTHICB">Learn More →
                                </router-link>
                            </div>
                            <img class="slide-img"
                                 :src="baseUrl+newsImages[index][0].headpic.url"
                                 alt="">
                        </div>
                        <img v-if="tabIndex===3&&index===4" class="slide-img certificate"
                             :src="baseUrl+item.certificates[0].url" alt="">
                        <img v-if="tabIndex===3&&index!==4" class="slide-img" :src="baseUrl+item.media.url" alt="">
                    </div>
                    <div class="slide-btn-container">
                        <hover-flash-button is-router-link
                                            :router-link-to="{name:routerName,params:{slug:item.slug}}"
                                            backgroundColor="black" text="View All →" class="f-GOTHICB slide-btn"/>
                    </div>
                    <img v-show="currentSlideIndex!==0" class="prev-slide-icon"
                         src="../assets/images/prev-slide-black-icon.png"
                         alt="" slot="button-prev">
                    <img v-show="currentSlideIndex!==sectionData.length-1" class="next-slide-icon"
                         src="../assets/images/next-slide-black-icon.png" alt="" slot="button-next">
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-background" :style="{backgroundColor:sectionData[currentSlideIndex].backgroundColor}"></div>
    </div>
</template>

<script>
    import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    import HoverFlashButton from '@/components/HoverFlashButton.vue'
    import {homeDataMixin} from '../mixins'
    import dayjs from 'dayjs'

    export default {
        name: "MSectionSwiper",
        components: {
            Swiper,
            SwiperSlide,
            HoverFlashButton
        },
        mixins: [homeDataMixin],
        props: {tabIndex: Number, sectionData: Array, slideIndex: Number, routerName: String},
        data() {
            return {
                swiperOptionImages: {
                    navigation: {
                        nextEl: '.next-slide-icon',
                        prevEl: '.prev-slide-icon',
                    }
                },
                swiperOptionNav: {
                    slidesPerView: 'auto',
                    slideToClickedSlide: true,
                    centeredSlides: true,
                },
                currentSlideIndex: 0,
                dayjs: dayjs,
            }
        },
        mounted() {
            this.$nextTick(() => {
                const swiperNav = this.$refs.swiperNav.$swiper
                const swiperImages = this.$refs.swiperImages.$swiper
                swiperNav.controller.control = swiperImages
                swiperImages.controller.control = swiperNav
                swiperNav.slideTo(this.slideIndex)
                swiperImages.slideTo(this.slideIndex)
            })
        },
        computed: {
            firstLineTitles() {
                return this.sectionData.map(item => this.getFirstLineTitle(item))
            },
            secondLineTitles() {
                return this.sectionData.map((item, index) => {
                        if (this.tabIndex === 2 && index === 1) {
                            return 'INFO'
                        } else {
                            return this.getSecondLineTitle(item)
                        }
                    }
                )
            },
            newsDisplayTime() {
                let time = this.newsImages[this.currentSlideIndex][0].displayTime
                return dayjs(time).format('MMM D,YYYY')
            },
        },
        watch: {
            slideIndex(val) {
                this.$refs.swiperNav.$swiper.slideTo(val)
                this.$refs.swiperImages.$swiper.slideTo(val)
            }
        },
        methods: {
            getSlideIndex() {
                this.currentSlideIndex = this.$refs.swiperNav.$swiper.realIndex
            },
        }
    }
</script>

<style scoped>

    .section-container {
        height: 1136px;
    }

    .swiper-background {
        width: 100%;
        height: 68%;
        background: lightblue;
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        background-image: url("../assets/images/background.png");
    }

    .nav-swiper-container {
        padding: 126px 0 50px 30px;
        box-sizing: border-box;
        line-height: 30px;
    }

    .nav-swiper-container .swiper-slide {
        width: auto;
        padding-right: 40px;
        font-size: 24px;
        font-family: GOTHICB, sans-serif;
        opacity: 0.55;
    }

    .nav-swiper-container .swiper-slide-active {
        font-size: 33px;
        opacity: 1;
    }

    .card-swiper-container {
        width: 100vw;
        height: 895px;
    }

    .card-slide {
        margin: 0 auto;
        width: 78vw;
        height: 865px;
        background: white;
        box-sizing: border-box;
        padding: 55px 55px 0 55px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 4px 7px 21px 0 rgba(11, 3, 6, 0.2);
        border-radius: 35px;
        position: relative;
    }

    .title-container {
        position: relative;
        width: 100%;
        font-family: pfd-Medium-3, sans-serif;
    }

    .title-arrow {
        width: 12px;
        height: 77px;
        position: absolute;
        left: -17px;
    }

    .title-line1 {
        font-size: 63px;
        line-height: 0.8;
    }

    .title-line2 {
        font-size: 16.4vw;
        line-height: 0.7;
    }

    .slide-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .small-img > :first-child {
        margin-top: 50px;
        height: 396px;
    }

    .big-img > :first-child {
        margin-top: 70px;
        height: 446px;
    }

    .prev-slide-icon, .next-slide-icon {
        width: 21px;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto 0;
        z-index: 2;
    }

    .prev-slide-icon {
        left: 20px;
    }

    .next-slide-icon {
        right: 20px;
    }

    .slide-btn-container {
        flex: 1;
        display: flex;
        align-items: center;
    }

    .slide-btn {
        width: 248px;
        height: 64px;
        font-size: 29px;
    }

    .certificate {
        width: unset;
    }

    .news-imge-container {
        position: relative;
        margin-top: 60px;
    }

    .news-info {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 114px;
        background-color: #000000;
        opacity: 0.75;
        padding: 15px;
        box-sizing: border-box;
        color: white;
    }

    .news-info .display-time {
        font-size: 24px;
        margin-bottom: 10px;
        line-height: 0.8;
    }

    .news-info .description {
        font-size: 18px;
        opacity: 0.5;
        line-height: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }

    .learn-more {
        font-size: 20px;
        color: #06c59a;
        text-align: right;
        cursor: pointer;
    }
</style>